<template>
    <div class="glass-theme fade-in-page">
        <div :style="{'width': '95%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px', 'padding-bottom': '100px'}">
            
            <!-- API Loading Overlay with Animation - Fixed height version -->
            <transition name="loading-overlay">
                <div v-if="apiLoading" class="loading-overlay">
                    <div class="loading-card glass-loader-card">
                        <div class="loading-animation">
                            <div class="loading-ring">
                                <div class="ring"></div>
                                <div class="ring"></div>
                                <div class="ring"></div>
                                <div class="loading-logo">
                                    <i class="fas fa-chart-line"></i>
                                </div>
                            </div>
                        </div>
                        <div class="loading-text">
                            <h3>{{ loadingMessage }}</h3>
                            <div class="loading-dots">
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                            </div>
                        </div>
                        <div class="loading-progress">
                            <div class="progress-bar" :style="{ width: loadingProgress + '%' }"></div>
                        </div>
                        <div class="loading-tips loading-tips-fixed">
                            <p class="tip-text">{{ currentTip }}</p>
                        </div>
                    </div>
                </div>
            </transition>

            <div style="font-size: 25px; font-weight: bold; margin-bottom: 10px; width: 100%; text-align: center; color: #1e293b;">LAYAWAY SALES</div>

            <div v-if="isMobile" class="d-flex justify-content-between align-items-center mb-2 py-2">
                <b-button size="sm" variant="outline-primary" @click="filtersVisible = !filtersVisible" class="glass-btn-outline">
                    <b-icon-funnel-fill class="mr-1" />
                    {{ filtersVisible ? "Hide Filters" : "Show Filters" }}
                </b-button>
            </div>

            <b-collapse :visible="!isMobile || filtersVisible">
                <div style="text-align: center; padding: 10px; background: rgba(228, 244, 182, 0.8); backdrop-filter: blur(5px); margin-top: 10px; margin-bottom: 10px; border-radius: 16px;" class="glass-filters">

                    <div style="display: block;">
                        <div class="responsive-block" style="display: inline-block; margin: 10px; width: auto; background: rgba(239, 239, 239, 0.9); padding: 3px; border: 1px dashed rgba(0,0,0,0.2); border-radius: 12px; font-size: 12px; color: black;">
                            <b-card-text>
                                <span>DATES</span>
                                <b-input
                                    id="layawaydates"
                                    size="sm"
                                    variant="dark"
                                    :placeholder="[query.startDate, query.endDate].join(' - ')"
                                    style="display: inline-block; width: 220px;"
                                    class="responsive-input glass-input"
                                    autocomplete="off"
                                ></b-input>
                                <b-button size="sm" variant="dark" @click="search_dates" class="mt-1 mt-md-0 glass-btn-small">SEARCH</b-button>
                            </b-card-text>
                        </div>

                        <div class="responsive-block" style="display: inline-block; margin: 10px; width: auto; background: rgba(239, 239, 239, 0.9); padding: 3px; border: 1px dashed rgba(0,0,0,0.2); border-radius: 12px; font-size: 12px; color: black;">
                            <b-card-text>
                                <span>INVOICE # / NAME / EMAIL / PHONE: </span>
                                <span>
                                    <b-form @submit="search_invoice_id" style="display: inline-block;" class="responsive-input">
                                        <b-form-input
                                            v-model="query.invoice_id"
                                            size="sm"
                                            style="display: inline-block; width: 220px;"
                                            class="responsive-input glass-input"
                                            autocomplete="off"
                                        ></b-form-input>
                                        <b-button type="submit" size="sm" variant="dark" class="mt-1 mt-md-0 glass-btn-small">SEARCH</b-button>
                                    </b-form>
                                </span>
                            </b-card-text>
                        </div>
                    </div>

                    <div style="display: block;" v-if="sales.length > 0">
                        <div class="responsive-block" style="display: inline-block; margin: 10px; width: auto; background: rgba(239, 239, 239, 0.9); padding: 3px; border: 1px dashed rgba(0,0,0,0.2); border-radius: 12px; font-size: 12px; color: black;">
                            <b-card-text>
                                <b-form-select
                                    :options="getFilteredLocations()"
                                    v-model="picked_location_id"
                                    size="sm"
                                    style="width: 220px;"
                                    class="responsive-input glass-select"
                                >
                                    <template #first>
                                        <b-form-select-option :value="null" :disabled="false">--ALL LOCATIONS--</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-card-text>
                        </div>

                        <div class="responsive-block" style="display: inline-block; margin: 10px; width: auto; background: rgba(239, 239, 239, 0.9); padding: 3px; border: 1px dashed rgba(0,0,0,0.2); border-radius: 12px; font-size: 12px; color: black;">
                            <b-card-text>
                                <b-form-select
                                    :options="filteredPaymentMethods"
                                    v-model="picked_payment_method"
                                    @change="onPaymentMethodChange"
                                    size="sm"
                                    style="width: 250px;"
                                    class="responsive-input glass-select"
                                >
                                    <template #first>
                                        <b-form-select-option :value="null" :disabled="false">--ALL PAYMENT METHODS--</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-card-text>
                        </div>

                        <div class="responsive-block" style="display: inline-block; margin: 10px; width: auto; background: rgba(239, 239, 239, 0.9); padding: 3px; border: 1px dashed rgba(0,0,0,0.2); border-radius: 12px; font-size: 12px; color: black;">
                            <b-card-text>
                                <span>STATUS</span>
                                <b-form-select
                                    :options="combined_status_options"
                                    v-model="combined_status_filter"
                                    size="sm"
                                    style="width: 150px;"
                                    class="responsive-input glass-select"
                                ></b-form-select>
                            </b-card-text>
                        </div>

                        <div class="responsive-block" style="display: inline-block; margin: 10px; width: auto; background: rgba(239, 239, 239, 0.9); padding: 3px; border: 1px dashed rgba(0,0,0,0.2); border-radius: 12px; font-size: 12px; color: black;">
                            <b-card-text>
                                <span>SALE TYPE</span>
                                <b-form-select
                                    :options="sale_type_options"
                                    v-model="sale_type_filter"
                                    size="sm"
                                    style="width: 200px;"
                                    class="responsive-input glass-select"
                                ></b-form-select>
                            </b-card-text>
                        </div>

                        <div class="responsive-block" style="display: inline-block; margin: 10px; width: auto; background: rgba(239, 239, 239, 0.9); padding: 3px; border: 1px dashed rgba(0,0,0,0.2); border-radius: 12px; font-size: 12px; color: black;">
                            <b-card-text>
                                <span>ORDER TYPE</span>
                                <b-form-select
                                    :options="orderTypeOptions"
                                    v-model="orderTypeFilter"
                                    size="sm"
                                    style="width: 200px;"
                                    class="responsive-input glass-select"
                                ></b-form-select>
                            </b-card-text>
                        </div>

                        <div class="responsive-block" style="display: inline-block; margin: 10px; width: auto; background: none; padding: 3px; border: 0px; font-size: 12px; color: black;"
                            v-if="sales.length > 0 && ['admin'].includes(packet.userDetails.userrole)">
                            <div>&nbsp;</div>
                            <download-csv
                                class="btn responsive-input glass-btn"
                                :data="get_csv_data()"
                                :name="get_csv_filename()"
                                style="border: 1px solid black; width: 180px; background: linear-gradient(135deg, #1e293b, #0f172a); color: white;"
                            >
                                DOWNLOAD EXCEL
                            </download-csv>
                        </div>
                    </div>
                </div>
            </b-collapse>

            <div>
                <div v-if="sales_being_loaded == true && !apiLoading">
                    <loading :active="true" :can-cancel="false" :is-full-page="true"></loading>
                </div>

                <div v-else>
                    <div v-if="sales.length > 0" style="overflow-x: auto">
                        <table style="width: 100%; font-size: 11px;" id="sales-table" class="glass-table">
                            <thead>
                                <tr style="background: linear-gradient(135deg, #1e293b, #0f172a); color: white; font-weight: bold;">
                                    <th class="ipt_tdhr" style="min-width: 100px;" @click="sortby('datetime')">
                                        DATE <span class="sort-icon">↕</span>
                                    </th>
                                    <th class="ipt_tdhr" style="min-width: 100px;" @click="sortby('invoice_id')">
                                        INVOICE # <span class="sort-icon">↕</span>
                                    </th>
                                    <th class="ipt_tdhr" style="min-width: 130px;" @click="sortby('customer')">
                                        CUSTOMER <span class="sort-icon">↕</span>
                                    </th>
                                    <th class="ipt_tdhr" style="min-width: 130px;">ORDER TYPES</th>
                                    <th class="ipt_tdhr" style="min-width: 150px;" @click="sortby('location_id')">
                                        LOCATION <span class="sort-icon">↕</span>
                                    </th>
                                    <th class="ipt_tdhr" style="min-width: 100px;" @click="sortby('username')">
                                        SALES AGENT <span class="sort-icon">↕</span>
                                    </th>
                                    <th class="ipt_tdhr" style="min-width: 100px;" @click="sortby('delivery_dates')">
                                        DELIVERY DATES <span class="sort-icon">↕</span>
                                    </th>
                                    <th class="ipt_tdhr" style="min-width: 100px;">PAYMENT AMOUNT</th>
                                    <th class="ipt_tdhr" style="min-width: 100px;">PAYMENT METHOD</th>
                                    <th class="ipt_tdhr" style="min-width: 100px;" @click="sortby('status_display')">
                                        STATUS <span class="sort-icon">↕</span>
                                    </th>
                                    <th class="ipt_tdhr" style="min-width: 180px;">ACTIONS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style="background-color: rgba(255, 235, 59, 0.3);" class="totals-row">
                                    <td class="ipt_tdhr" @click="sortby('datetime')"></td>
                                    <td class="ipt_tdhr" @click="sortby('invoice_id')"></td>
                                    <td class="ipt_tdhr" @click="sortby('customer')"></td>
                                    <td class="ipt_tdhr"></td>
                                    <td class="ipt_tdhr" @click="sortby('location_id')"></td>
                                    <td class="ipt_tdhr" @click="sortby('username')"></td>
                                    <td class="ipt_tdhr" @click="sortby('delivery_dates')"></td>
                                    <td class="ipt_tdhr" style="background: #e8f5e8;">
                                        <div style="font-weight: bold; color: #28a745;">${{ formatCurrency(total()) }}</div>
                                        <div style="font-size: 9px; color: #666;">Gross Total</div>
                                    </td>
                                    <td class="ipt_tdhr"></td>
                                    <td class="ipt_tdhr"></td>
                                    <td class="ipt_tdhr"></td>
                                </tr>

                                <tr v-for="(sale, idx) in sales" v-if="allowed(sale)==true && row_part_of_chunk(idx)" :key="idx" :class="{'highlight-match': isPaymentMethodMatch(sale), 'fade-in-row': true}" :style="{ animationDelay: `${idx * 0.02}s` }">
                                    <td class="ipt_tdr">{{ sale.datetime }}</td>
                                    <td class="ipt_tdr" :style="{background: getInvBg(idx)}">
                                        {{ ( sale.invoice_id || "" ).toUpperCase() }}
                                        <div v-if="sale.transaction_type === 'REFUND'" style="color: #dc3545; padding: 3px; font-weight: bold; background: #ffe6e6; border: 1px solid #dc3545; border-radius: 6px; margin-top: 2px;">
                                            REFUND
                                        </div>
                                        <div v-if="sale.is_layaway && sale.transaction_type !== 'REFUND'" style="color: red; padding: 3px; font-weight: bold;">LAYAWAY SALE</div>
                                        <div v-if="sale.total_payments > 1" style="font-size: 9px; color: #666; background: rgba(0,0,0,0.05); padding: 2px; margin-top: 2px; border-radius: 4px;">
                                            Payment {{ sale.payment_index + 1 }} of {{ sale.total_payments }}
                                        </div>
                                    </td>

                                    <td class="ipt_tdr">
                                        <div class="customer-cell">
                                            <strong>{{ ( sale.customer_fullname || "" ).toUpperCase() }}</strong>
                                            <div class="customer-phone">{{ ( sale.customer_phone || "" ).toUpperCase() }}</div>
                                        </div>
                                    </td>

                                    <td class="ipt_tdr">
                                        <div v-if="getUniqueOrderTypes(sale).length > 0">
                                            <div v-for="orderType in getOrderTypesWithCount(sale)" :key="orderType.type" :style="getOrderTypeStyle(orderType.type)" class="order-type-badge" style="margin: 2px 0; padding: 3px; font-size: 10px;">
                                                {{ formatOrderTypeDisplay(orderType) }}
                                            </div>
                                            <div v-if="getUniqueOrderTypes(sale).length > 2">
                                                <b-button size="sm" variant="outline-info" @click="showOrderTypes(sale)" class="order-types-btn mt-1 glass-btn-small">
                                                    View All ({{ getUniqueOrderTypes(sale).length }})
                                                </b-button>
                                            </div>
                                        </div>
                                        <div v-else style="color: #999; font-style: italic; font-size: 10px;">No types</div>
                                    </td>
                                    <td class="ipt_tdr">{{ ( packet.locationsdict[sale.location_id] || "" ).toUpperCase() }} / {{ (packet.sublocationsdict[sale.sublocation_id] || "").toUpperCase() }}</td>
                                    <td class="ipt_tdr">{{ sale.username }}</td>
                                    <td class="ipt_tdr">
                                        <div v-if="sale.delivery_dates && sale.delivery_dates.length > 0">
                                            <b-button v-if="sale.delivery_dates.length > 1" size="sm" variant="outline-primary" @click="showDeliveryDates(sale)" class="delivery-dates-btn glass-btn-small">
                                                {{ sale.delivery_dates.length }} Dates
                                            </b-button>
                                            <div v-else v-for="(ddate, ddidx) in sale.delivery_dates" :key="ddidx" style="padding: 3px; text-align: center; background: rgba(255, 235, 59, 0.3); color: black; border-radius: 6px;">
                                                {{ ddate }}
                                            </div>
                                        </div>
                                        <div v-else style="color: #999; font-style: italic;">No dates</div>
                                    </td>
                                    <td class="ipt_tdr" @click="showPaymentHistory(sale)" style="cursor: pointer; text-decoration: underline;" :title="'Click to view payment history for ' + sale.invoice_id">
                                        <div v-if="sale.transaction_type === 'REFUND'" style="font-weight: bold; color: #dc3545;">
                                            -${{ formatCurrency(sale.payment_amount || Math.abs(sale.transaction_amount)) }}
                                        </div>
                                        <div v-else style="font-weight: bold; color: #28a745;">
                                            ${{ formatCurrency(sale.payment_amount || sale.paid_so_far) }}
                                        </div>
                                        <div style="font-size: 9px; color: #666;">{{ sale.transaction_type === 'REFUND' ? 'Refund Amount' : 'Payment Amount' }}</div>
                                        <div v-if="sale.grand_total && sale.transaction_type !== 'REFUND'" style="font-size: 8px; color: #888;">Total: ${{ formatCurrency(sale.grand_total) }}</div>
                                        <div style="font-size: 8px; color: #888;">Click to view details</div>
                                    </td>
                                    <td class="ipt_tdr">
                                        <div v-if="sale.payment_methods && sale.payment_methods.length > 0" class="payment-methods-compact">
                                            <span v-for="(method, index) in getPaymentMethodsDisplay(sale.payment_methods)" :key="index" :class="getPaymentMethodTextClass(method)" style="display: inline-block; margin: 2px;">
                                                {{ method }}
                                            </span>
                                        </div>
                                        <div v-else style="color: #999; font-style: italic; font-size: 10px;">No payment methods</div>
                                    </td>
                                    <td class="ipt_tdr">
                                        <div v-if="sale.transaction_type === 'REFUND'" style="background: #ffe6e6; color: #dc3545; padding: 3px; text-align: center; font-weight: bold; border: 1px solid #dc3545; border-radius: 6px;">
                                            REFUNDED
                                        </div>
                                        <div v-else :style="getStatusStyle(sale)" class="status-badge">
                                            {{ getStatusDisplay(sale) }}
                                            <div v-if="sale.completed" style="font-size: 8px; margin-top: 2px; font-weight: bold;">COMPLETED</div>
                                            <div v-else style="font-size: 8px; margin-top: 2px; color: #666;">IN PROGRESS</div>
                                        </div>
                                    </td>
                                    <td class="ipt_tdr">
                                        <div style="margin: 3px;">
                                            <b-button size="sm" variant="outline-dark" @click="navigateToInvoice(idx)" class="glass-btn-small">VIEW SALE</b-button>
                                            <b-button size="sm" variant="outline-warning" v-if="!isArchived(sale) && sale.transaction_type !== 'REFUND' && ['admin'].includes(packet.userDetails.userrole)" @click="archive_invoice(sale.invoice_id)" class="glass-btn-small mt-1">ARCHIVE</b-button>
                                            <b-button size="sm" variant="outline-info" v-if="isArchived(sale) && ['admin', 'locationadmin', 'locationmanager'].includes(packet.userDetails.userrole)" @click="unarchive_invoice(sale.invoice_id)" class="glass-btn-small mt-1">UNARCHIVE</b-button>
                                            <b-button size="sm" variant="outline-danger" v-if="isArchived(sale) && packet.userDetails.userrole == 'admin'" @click="void_invoice(sale.invoice_id)" class="glass-btn-small mt-1">VOID</b-button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <!-- Delivery Dates Modal -->
            <b-modal id="delivery-dates-modal" size="md" title="📅 Delivery Dates" hide-footer header-bg-variant="info" header-text-variant="white" centered class="glass-modal">
                <div v-if="selectedSale" class="delivery-dates-content">
                    <div class="delivery-header mb-4 p-3 bg-light rounded glass-card-inner">
                        <h6 class="mb-1 text-dark"><strong>{{ selectedSale.invoice_id }}</strong></h6>
                        <p class="mb-0 text-muted small">{{ selectedSale.customer_fullname }} • {{ selectedSale.customer_phone }}</p>
                    </div>

                    <div class="dates-list">
                        <div v-for="(date, index) in selectedSale.delivery_dates" :key="index" class="date-item" :class="{'upcoming-date': isUpcomingDate(date)}">
                            <div class="date-icon"><i class="fas fa-truck"></i></div>
                            <div class="date-details">
                                <div class="date-display">{{ formatDeliveryDate(date) }}</div>
                                <div class="date-status" :class="getDateStatusClass(date)">{{ getDateStatus(date) }}</div>
                            </div>
                            <div class="date-badge"><b-badge :variant="getDateBadgeVariant(index)">#{{ index + 1 }}</b-badge></div>
                        </div>
                    </div>

                    <div class="dates-summary mt-4 p-3 bg-light rounded glass-card-inner">
                        <div class="row text-center">
                            <div class="col-6"><small class="text-muted d-block">Total Dates</small><strong class="text-dark">{{ selectedSale.delivery_dates.length }}</strong></div>
                            <div class="col-6"><small class="text-muted d-block">Upcoming</small><strong class="text-primary">{{ getUpcomingDatesCount(selectedSale.delivery_dates) }}</strong></div>
                        </div>
                    </div>

                    <div class="modal-footer mt-4 pt-3 border-top"><b-button variant="secondary" @click="$bvModal.hide('delivery-dates-modal')" class="glass-btn">Close</b-button></div>
                </div>
            </b-modal>

            <!-- Order Types Modal -->
            <b-modal id="order-types-modal" size="md" title="📦 Order Types" hide-footer header-bg-variant="info" header-text-variant="white" centered class="glass-modal">
                <div v-if="selectedSale" class="order-types-content">
                    <div class="order-header mb-4 p-3 bg-light rounded glass-card-inner">
                        <h6 class="mb-1 text-dark"><strong>{{ selectedSale.invoice_id }}</strong></h6>
                        <p class="mb-0 text-muted small">{{ selectedSale.customer_fullname }} • {{ selectedSale.customer_phone }}</p>
                    </div>

                    <div class="order-types-list">
                        <div v-for="(orderType, index) in getOrderTypesWithCount(selectedSale)" :key="index" class="order-type-item" :class="getOrderTypeItemClass(orderType.type)">
                            <div class="order-type-icon"><i :class="getOrderTypeIcon(orderType.type)"></i></div>
                            <div class="order-type-details">
                                <div class="order-type-display">{{ formatOrderType(orderType.type) }}</div>
                                <div class="order-type-count">{{ orderType.count }} item{{ orderType.count > 1 ? 's' : '' }}</div>
                            </div>
                            <div class="order-type-badge"><b-badge :variant="getOrderTypeBadgeVariant(orderType.type)">{{ getOrderTypeAbbreviation(orderType.type) }}</b-badge></div>
                        </div>
                    </div>

                    <div class="order-summary mt-4 p-3 bg-light rounded glass-card-inner">
                        <div class="row text-center">
                            <div class="col-6"><small class="text-muted d-block">Total Types</small><strong class="text-dark">{{ getUniqueOrderTypes(selectedSale).length }}</strong></div>
                            <div class="col-6"><small class="text-muted d-block">Total Items</small><strong class="text-primary">{{ selectedSale.items.length }}</strong></div>
                        </div>
                    </div>

                    <div class="modal-footer mt-4 pt-3 border-top"><b-button variant="secondary" @click="$bvModal.hide('order-types-modal')" class="glass-btn">Close</b-button></div>
                </div>
            </b-modal>

            <!-- Payment History Modal -->
            <b-modal id="payment-history-modal" size="lg" title="💳 Payment History" hide-footer header-bg-variant="dark" header-text-variant="white" centered class="glass-modal">
                <div v-if="selectedInvoice" class="payment-modal-content">
                    <div class="payment-header mb-4 p-3 bg-light rounded glass-card-inner">
                        <div class="row align-items-center">
                            <div class="col-md-8">
                                <h6 class="mb-1 text-primary"><strong>{{ selectedInvoice.invoice_id }}</strong></h6>
                                <p class="mb-1 text-dark">{{ selectedInvoice.customer_fullname }}</p>
                                <p class="mb-0 text-muted small">{{ selectedInvoice.customer_phone }} • {{ selectedInvoice.email }}</p>
                            </div>
                            <div class="col-md-4 text-right">
                                <div class="amount-summary">
                                    <div class="total-section"><small class="text-muted d-block">Total Amount</small><span class="h5 text-dark">${{ formatCurrency(selectedInvoice.grand_total) }}</span></div>
                                    <div class="paid-section mt-2"><small class="text-muted d-block">{{ selectedInvoice.is_layaway ? 'Paid So Far' : 'Amount Paid' }}</small>
                                        <span class="h5" :class="selectedInvoice.is_layaway ? 'text-success' : 'text-dark'">${{ formatCurrency(getTotalPaid(selectedInvoice)) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="selectedInvoice.is_layaway" class="progress-section mb-4 glass-card-inner">
                        <div class="d-flex justify-content-between mb-1"><small class="text-muted">Payment Progress</small><small class="text-muted">{{ Math.round((getTotalPaid(selectedInvoice) / selectedInvoice.grand_total) * 100) }}%</small></div>
                        <b-progress height="6px" :value="getTotalPaid(selectedInvoice)" :max="selectedInvoice.grand_total" variant="success" class="glass-progress"></b-progress>
                        <div class="text-center mt-1"><small class="text-warning"><strong>Remaining: ${{ formatCurrency((selectedInvoice.grand_total || 0) - (getTotalPaid(selectedInvoice) || 0)) }}</strong></small></div>
                    </div>

                    <div class="section-card mb-3">
                        <div class="section-header section-header-active"><div class="section-title"><i class="fas fa-receipt mr-2"></i>Payment Transactions <b-badge variant="primary" class="ml-2">{{ selectedInvoice.payment_details ? selectedInvoice.payment_details.length : 0 }}</b-badge></div></div>
                        <div class="section-content">
                            <div v-if="selectedInvoice.payment_details && selectedInvoice.payment_details.length > 0" class="payment-list">
                                <div v-for="(payment, idx) in selectedInvoice.payment_details" :key="idx" class="payment-item" :class="{'recent-payment': isRecentPayment(payment.ts)}">
                                    <div class="payment-method-icon" :class="getPaymentMethodClass(payment.value)">{{ getPaymentMethodIcon(payment.value) }}</div>
                                    <div class="payment-details">
                                        <div class="payment-method"><strong>{{ getPaymentMethodDisplay(payment.value) }}</strong><small class="text-muted d-block">{{ formatPaymentDate(payment.ts) }}</small></div>
                                        <div class="payment-amount text-success">${{ formatCurrency(payment.amount) }}</div>
                                    </div>
                                    <div class="payment-extra">
                                        <b-badge v-if="payment.store_credit_invoice_id" variant="info" class="small">Store Credit</b-badge>
                                        <b-badge v-else-if="payment.charged_tax_itself" variant="warning" class="small">Tax Included</b-badge>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="text-center py-4 text-muted"><i class="fas fa-receipt fa-2x mb-2"></i><p>No payment transactions found</p></div>
                        </div>
                    </div>

                    <div class="modal-footer mt-4 pt-3 border-top">
                        <b-button variant="secondary" @click="$bvModal.hide('payment-history-modal')" class="mr-2 glass-btn-small">Close</b-button>
                        <b-button variant="primary" @click="navigateToSelectedInvoice" class="glass-btn"><i class="fas fa-external-link-alt mr-2"></i>View Full Invoice</b-button>
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
    import 'bootstrap/dist/css/bootstrap.css'
    import 'bootstrap-vue/dist/bootstrap-vue.css'
    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table'

    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";

    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css'

    import 'lightpick/css/lightpick.css'
    import moment from 'moment'
    import { BIconFunnelFill } from 'bootstrap-vue'

    export default {
        name: "ListLayAwaySales",
        props: ["showbacker"],
        components: {Backer, VueGoodTable, Multiselect, Loading},
        data: function() {
            return {
                packet: {},
                sales: [],
                sales_being_loaded: false,
                query: {
                    startDate: null,
                    endDate: null,
                    invoice_id: null,
                },
                selectedSale: null,
                selectedInvoice: null,
                picked_location_id: null,
                finance_companies: [],
                orderTypeFilter: "all",
                orderTypeOptions: [
                    {value: "all", text: "ALL ORDER TYPES"},
                    {value: "home_delivery", text: "HOME DELIVERY"},
                    {value: "store_pickup", text: "STORE PICKUP"},
                ],
                payment_methods: [
                    {value: "CASH", text: "CASH INVOLVED"},
                    {value: "CC", text: "CC INVOLVED"},
                    {value: "STORE_CREDIT", text: "STORE CREDIT INVOLVED"},
                    {value: "FINANCE", text: "FINANCE INVOLVED"},
                    {value: "TAX_EXEMPT", text: "TAX EXEMPT INVOLVED"}
                ],
                combined_status_filter: "all",
                combined_status_options: [
                    {value: "all", text: "ALL"},
                    {value: "new", text: "NEW"},
                    {value: "open", text: "OPEN"},
                    {value: "processed", text: "PROCESSED"},
                    {value: "partial", text: "PARTIAL"},
                    {value: "backorder", text: "BACKORDER"},
                    {value: "delivered", text: "DELIVERED"},
                    {value: "completed", text: "COMPLETED"},
                    {value: "archived", text: "ARCHIVED"}
                ],
                status_filter: "all",
                status_options: [
                    {value: "all", text: "ALL STATUSES"},
                    {value: "0", text: "NEW"},
                    {value: "1", text: "OPEN"},
                    {value: "2", text: "PROCESSED ONLY"},
                    {value: "3", text: "BACKORDER"},
                    {value: "4", text: "PARTIAL"},
                    {value: "5", text: "DELIVERED"}
                ],
                completion_filter: "all",
                completion_options: [
                    {value: "all", text: "ALL COMPLETION"},
                    {value: "not_completed", text: "NOT COMPLETED ONLY"},
                    {value: "completed", text: "COMPLETED ONLY"}
                ],
                sale_type_filter: "layaway",
                sale_type_options: [
                    {value: "layaway", text: "LAYAWAY SALES ONLY"},
                ],
                picked_payment_method: null,
                chunksize: 2000000,
                chunkoptions: [],
                chunk_allowed: null,
                invoice_type_options: [
                    {value: "regular", text: "REGULAR"},
                    {value: "layaway", text: "LAYAWAY"},
                ],
                invoice_type: "layaway",
                sort_asc: true,
                filtersVisible: false,
                isMobile: false,
                // Loading animation properties
                apiLoading: false,
                loadingMessage: "Loading Layaway Sales",
                loadingProgress: 0,
                currentTipIndex: 0,
                loadingInterval: null,
                tipInterval: null,
                msgInterval: null,
                apiCallStack: 0,
                tips: [
                    "💰 Loading layaway sales data...",
                    "📊 Fetching payment history...",
                    "🔄 Processing layaway details...",
                    "📈 Calculating totals...",
                    "✨ Organizing layaway records...",
                    "💳 Updating payment status..."
                ]
            }
        },
        computed: {
            currentTip() {
                return this.tips[this.currentTipIndex] || this.tips[0];
            },
            filteredPaymentMethods: function() {
                let availableMethods = [
                    {value: "CASH", text: "CASH INVOLVED"},
                    {value: "CC", text: "CC INVOLVED"},
                    {value: "STORE_CREDIT", text: "STORE CREDIT INVOLVED"},
                    {value: "FINANCE", text: "FINANCE INVOLVED"},
                    {value: "TAX_EXEMPT", text: "TAX EXEMPT INVOLVED"}
                ];

                const presentMethods = new Set();

                this.sales.forEach(sale => {
                    if (sale.payment_methods && Array.isArray(sale.payment_methods)) {
                        sale.payment_methods.forEach(payment => {
                            if (payment && payment.value) {
                                if (payment.value === "cash") presentMethods.add("CASH");
                                if (payment.value === "cc") presentMethods.add("CC");
                                if (payment.value === "store_credit") presentMethods.add("STORE_CREDIT");
                                if (payment.value === "finance") presentMethods.add("FINANCE");
                                if (payment.value === "tax_exempt") presentMethods.add("TAX_EXEMPT");

                                if (payment.value === "finance" && payment.name && payment.name !== "N/A") {
                                    const financeOption = "FINANCE - " + payment.name;
                                    presentMethods.add(financeOption);
                                }
                                if (payment.value === "tax_exempt" && payment.name && payment.name !== "N/A") {
                                    const taxExemptOption = "TAX_EXEMPT - " + payment.name;
                                    presentMethods.add(taxExemptOption);
                                }
                            }
                        });
                    }
                });

                availableMethods = availableMethods.filter(method => presentMethods.has(method.value));

                this.finance_companies.forEach(fc => {
                    const financeOptionValue = "FINANCE - " + fc.finance_company_name;
                    if (presentMethods.has(financeOptionValue)) {
                        availableMethods.push({
                            value: financeOptionValue,
                            text: "FINANCE - " + fc.finance_company_name + " INVOLVED"
                        });
                    }

                    if (fc.company_type === "tax_exempt") {
                        const taxExemptOptionValue = "TAX_EXEMPT - " + fc.finance_company_name;
                        if (presentMethods.has(taxExemptOptionValue)) {
                            availableMethods.push({
                                value: taxExemptOptionValue,
                                text: "TAX EXEMPT - " + fc.finance_company_name + " INVOLVED"
                            });
                        }
                    }
                });

                return availableMethods;
            }
        },
        methods: {
            // Loading animation methods
            startApiLoading(message = "Loading Layaway Sales") {
                this.apiCallStack++;
                if (!this.apiLoading) {
                    this.startLoadingAnimation(message);
                } else {
                    this.loadingMessage = message;
                }
            },
            stopApiLoading() {
                this.apiCallStack--;
                if (this.apiCallStack <= 0 && this.apiLoading) {
                    this.stopLoadingAnimation(true);
                }
            },
            startLoadingAnimation(message = "Loading Layaway Sales") {
                this.apiLoading = true;
                this.loadingMessage = message;
                this.loadingProgress = 0;
                this.currentTipIndex = 0;
                
                this.loadingInterval = setInterval(() => {
                    if (this.loadingProgress < 90) {
                        this.loadingProgress += Math.random() * 10;
                        if (this.loadingProgress > 90) this.loadingProgress = 90;
                    }
                }, 300);
                
                this.tipInterval = setInterval(() => {
                    if (this.currentTipIndex < this.tips.length - 1) {
                        this.currentTipIndex++;
                    }
                }, 2000);
                
                let messages = ['Loading Layaway Sales', 'Fetching Data', 'Processing Transactions', 'Calculating Totals', 'Finalizing'];
                let msgIndex = 0;
                this.msgInterval = setInterval(() => {
                    if (msgIndex < messages.length - 1) {
                        msgIndex++;
                        this.loadingMessage = messages[msgIndex];
                    }
                }, 1800);
            },
            stopLoadingAnimation(success = true) {
                if (this.loadingInterval) clearInterval(this.loadingInterval);
                if (this.tipInterval) clearInterval(this.tipInterval);
                if (this.msgInterval) clearInterval(this.msgInterval);
                
                if (success) {
                    this.loadingProgress = 100;
                    setTimeout(() => {
                        this.apiLoading = false;
                    }, 500);
                } else {
                    this.apiLoading = false;
                }
            },
            
            handleResize() {
                this.isMobile = window.innerWidth < 768;
            },
            formatOrderTypeDisplay: function(orderType) {
                const typeName = this.formatOrderType(orderType.type);
                return `${typeName} (${orderType.count} item${orderType.count > 1 ? 's' : ''})`;
            },
            isArchived: function(sale) {
                return sale.status === 10;
            },
            archive_invoice: function(invoice_id) {
                let that = this;
                let path = "/api/sales/archive_invoice/";
                let data = {invoice_id: invoice_id};

                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(response.data.error, {title: "Error", autoHideDelay: 1500, variant:"warning"});
                    } else {
                        that.$bvToast.toast("INVOICE ARCHIVED SUCCESSFULLY", {title: "Success", autoHideDelay: 1500, variant:"success"});
                        that.fetch_init();
                    }
                }

                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast("Error archiving invoice.", {title: "Error", autoHideDelay: 1500, variant:"warning"});
                }

                Requestor.postSyncP(path, data, this, s, f);
            },
            unarchive_invoice: function(invoice_id) {
                let that = this;
                let path = "/api/sales/unarchive_invoice/";
                let data = {invoice_id: invoice_id};

                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(response.data.error, {title: "Error", autoHideDelay: 1500, variant:"warning"});
                    } else {
                        that.$bvToast.toast("INVOICE UNARCHIVED SUCCESSFULLY", {title: "Success", autoHideDelay: 1500, variant:"success"});
                        that.fetch_init();
                    }
                }

                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast("Error unarchiving invoice.", {title: "Error", autoHideDelay: 1500, variant:"warning"});
                }

                Requestor.postSyncP(path, data, this, s, f);
            },
            getUniqueOrderTypes: function(sale) {
                if (!sale.items || !Array.isArray(sale.items)) return [];
                const orderTypes = [...new Set(sale.items.map(item => item.order_type))];
                return orderTypes.filter(type => type);
            },
            getOrderTypesWithCount: function(sale) {
                if (!sale.items || !Array.isArray(sale.items)) return [];
                const typeCount = {};
                sale.items.forEach(item => {
                    const type = item.order_type;
                    if (type) {
                        typeCount[type] = (typeCount[type] || 0) + 1;
                    }
                });
                return Object.keys(typeCount).map(type => ({
                    type: type,
                    count: typeCount[type]
                }));
            },
            showOrderTypes: function(sale) {
                this.selectedSale = { ...sale };
                this.$bvModal.show('order-types-modal');
            },
            formatOrderType: function(orderType) {
                if (!orderType) return 'Unknown';
                const typeMap = {
                    'home_delivery': 'Home Delivery',
                    'store_pickup': 'Store Pickup',
                    'curbside': 'Curbside Pickup',
                    'delivery': 'Delivery',
                    'pickup': 'Pickup'
                };
                return typeMap[orderType] || orderType.replace(/_/g, ' ').toUpperCase();
            },
            getOrderTypeStyle: function(orderType) {
                const baseStyle = "padding: 3px; text-align: center; font-weight: bold; border-radius: 4px; margin: 2px 0;";
                const styleMap = {
                    'home_delivery': baseStyle + "background: rgba(227, 242, 253, 0.9); color: #1565c0; border: 1px solid #1565c0;",
                    'store_pickup': baseStyle + "background: rgba(232, 245, 232, 0.9); color: #2e7d32; border: 1px solid #2e7d32;",
                    'curbside': baseStyle + "background: rgba(255, 243, 224, 0.9); color: #ef6c00; border: 1px solid #ef6c00;",
                    'delivery': baseStyle + "background: rgba(243, 229, 245, 0.9); color: #7b1fa2; border: 1px solid #7b1fa2;",
                    'pickup': baseStyle + "background: rgba(224, 242, 241, 0.9); color: #00695c; border: 1px solid #00695c;"
                };
                return styleMap[orderType] || baseStyle + "background: #f5f5f5; color: #666; border: 1px solid #ddd;";
            },
            getOrderTypeIcon: function(orderType) {
                const iconMap = {
                    'home_delivery': 'fas fa-home',
                    'store_pickup': 'fas fa-store',
                    'curbside': 'fas fa-car',
                    'delivery': 'fas fa-truck',
                    'pickup': 'fas fa-shopping-bag'
                };
                return iconMap[orderType] || 'fas fa-box';
            },
            getOrderTypeItemClass: function(orderType) {
                const classMap = {
                    'home_delivery': 'home-delivery-item',
                    'store_pickup': 'store-pickup-item',
                    'curbside': 'curbside-item',
                    'delivery': 'delivery-item',
                    'pickup': 'pickup-item'
                };
                return classMap[orderType] || 'default-order-item';
            },
            getOrderTypeBadgeVariant: function(orderType) {
                const variantMap = {
                    'home_delivery': 'primary',
                    'store_pickup': 'success',
                    'curbside': 'warning',
                    'delivery': 'info',
                    'pickup': 'dark'
                };
                return variantMap[orderType] || 'secondary';
            },
            getOrderTypeAbbreviation: function(orderType) {
                const abbrevMap = {
                    'home_delivery': 'HD',
                    'store_pickup': 'SP',
                    'curbside': 'CRB',
                    'delivery': 'DEL',
                    'pickup': 'PUP'
                };
                return abbrevMap[orderType] || 'OT';
            },
            getStatusDisplay: function(sale) {
                if (sale.status === 10) return 'ARCHIVED';
                if (sale.transaction_type === 'REFUND') return 'REFUNDED';
                if (sale.status_display) return sale.status_display;
                if (sale.status === 0) return 'NEW';
                if (sale.status === 1) return 'PROCESSED';
                if (sale.completed) return 'DELIVERED';
                if (sale.delivered_items && sale.total_items) {
                    if (sale.delivered_items === sale.total_items) return 'DELIVERED';
                    if (sale.delivered_items > 0 && sale.delivered_items < sale.total_items) return 'PARTIAL';
                }
                if (sale.backorder_items && sale.backorder_items > 0) return 'BACKORDER';
                return 'OPEN';
            },
            getStatusStyle: function(sale) {
                const status = this.getStatusDisplay(sale);
                const baseStyle = "padding: 3px; text-align: center; font-weight: bold; border-radius: 4px;";
                switch(status) {
                    case 'NEW': return baseStyle + "background: rgba(227, 242, 253, 0.9); color: #1565c0; border: 1px solid #1565c0;";
                    case 'OPEN': return baseStyle + "background: rgba(255, 243, 224, 0.9); color: #ef6c00; border: 1px solid #ef6c00;";
                    case 'PROCESSED': return baseStyle + "background: rgba(232, 245, 232, 0.9); color: #2e7d32; border: 1px solid #2e7d32;";
                    case 'BACKORDER': return baseStyle + "background: rgba(255, 235, 238, 0.9); color: #c62828; border: 1px solid #c62828;";
                    case 'PARTIAL': return baseStyle + "background: rgba(255, 248, 225, 0.9); color: #ff8f00; border: 1px solid #ff8f00;";
                    case 'DELIVERED': return baseStyle + "background: rgba(232, 245, 232, 0.9); color: #2e7d32; border: 1px solid #2e7d32;";
                    case 'COMPLETED': return baseStyle + "background: #4caf50; color: white; border: 1px solid #388e3c;";
                    case 'ARCHIVED': return baseStyle + "background: #FFCABF; color: black; border: 1px solid #495057;";
                    case 'REFUNDED': return baseStyle + "background: rgba(255, 235, 238, 0.9); color: #c62828; border: 1px solid #c62828;";
                    default: return baseStyle + "background: #f5f5f5; color: #666; border: 1px solid #ddd;";
                }
            },
            showDeliveryDates: function(sale) {
                this.selectedSale = { ...sale };
                this.$bvModal.show('delivery-dates-modal');
            },
            formatDeliveryDate: function(dateString) {
                if (!dateString) return 'N/A';
                try {
                    return moment(dateString).format('ddd, MMM DD, YYYY');
                } catch (e) {
                    return dateString;
                }
            },
            isUpcomingDate: function(dateString) {
                if (!dateString) return false;
                try {
                    const deliveryDate = moment(dateString).startOf('day');
                    const today = moment().startOf('day');
                    return deliveryDate.isSameOrAfter(today);
                } catch (e) {
                    return false;
                }
            },
            getDateStatus: function(dateString) {
                if (!dateString) return 'Unknown';
                try {
                    const deliveryDate = moment(dateString).startOf('day');
                    const today = moment().startOf('day');
                    if (deliveryDate.isBefore(today)) return 'Completed';
                    else if (deliveryDate.isSame(today)) return 'Today';
                    else if (deliveryDate.isSame(today.clone().add(1, 'day'))) return 'Tomorrow';
                    else {
                        const daysDiff = deliveryDate.diff(today, 'days');
                        return `In ${daysDiff} days`;
                    }
                } catch (e) {
                    return 'Unknown';
                }
            },
            getDateStatusClass: function(dateString) {
                if (!dateString) return 'text-muted';
                try {
                    const deliveryDate = moment(dateString).startOf('day');
                    const today = moment().startOf('day');
                    if (deliveryDate.isBefore(today)) return 'text-success';
                    else if (deliveryDate.isSame(today)) return 'text-warning font-weight-bold';
                    else return 'text-primary';
                } catch (e) {
                    return 'text-muted';
                }
            },
            getDateBadgeVariant: function(index) {
                const variants = ['primary', 'success', 'info', 'warning', 'danger', 'dark'];
                return variants[index % variants.length];
            },
            getUpcomingDatesCount: function(dates) {
                if (!dates || !Array.isArray(dates)) return 0;
                return dates.filter(date => this.isUpcomingDate(date)).length;
            },
            safeToNumber: function(value, defaultValue = 0) {
                if (value === null || value === undefined) return defaultValue;
                const num = parseFloat(value);
                return isNaN(num) ? defaultValue : num;
            },
            formatCurrency: function(value) {
                return this.safeToNumber(value).toFixed(2);
            },
            getTotalPaid: function(invoice) {
                if (!invoice.payment_details || !Array.isArray(invoice.payment_details)) {
                    return this.safeToNumber(invoice.paid_so_far);
                }
                return invoice.payment_details.reduce((total, payment) => {
                    return total + this.safeToNumber(payment.amount);
                }, 0);
            },
            debugPaymentMethods: function() {
                console.log("=== PAYMENT METHODS DEBUG ===");
                console.log("Selected payment method:", this.picked_payment_method);
                this.sales.forEach((sale, index) => {
                    const paymentMethods = sale.payment_methods || [];
                    console.log("Sale " + index + " (" + sale.invoice_id + "):", {
                        payment_methods: paymentMethods,
                        payment_amount: sale.payment_amount,
                        total_payments: sale.total_payments,
                        payment_index: sale.payment_index
                    });
                });
            },
            onPaymentMethodChange: function() {
                this.debugPaymentMethods();
            },
            isPaymentMethodMatch: function(sale) {
                if (!this.picked_payment_method) return false;
                var pms = sale.payment_methods || [];
                var picked_payment_method = this.picked_payment_method;
                return pms.some(function(payment) {
                    if (!payment || !payment.value) return false;
                    if (picked_payment_method === "CASH") return payment.value === "cash";
                    if (picked_payment_method === "CC") return payment.value === "cc";
                    if (picked_payment_method === "STORE_CREDIT") return payment.value === "store_credit";
                    if (picked_payment_method === "FINANCE") return payment.value === "finance";
                    if (picked_payment_method === "TAX_EXEMPT") return payment.value === "tax_exempt";
                    if (picked_payment_method.startsWith("FINANCE - ")) {
                        return payment.value === "finance" && payment.name === picked_payment_method.replace("FINANCE - ", "");
                    }
                    if (picked_payment_method.startsWith("TAX_EXEMPT - ")) {
                        return payment.value === "tax_exempt" && payment.name === picked_payment_method.replace("TAX_EXEMPT - ", "");
                    }
                    return false;
                });
            },
            getPaymentMethodDisplay: function(method) {
                const methodMap = {
                    'cash': 'CASH',
                    'cc': 'CREDIT CARD',
                    'store_credit': 'STORE CREDIT',
                    'finance': 'FINANCE',
                    'tax_exempt': 'TAX EXEMPT'
                };
                return methodMap[method] || (method ? method.toUpperCase() : 'UNKNOWN');
            },
            getPaymentMethodTextClass: function(method) {
                if (!method) return 'payment-text-default';
                const classMap = {
                    'CASH': 'payment-text-cash',
                    'CC': 'payment-text-cc',
                    'STORE CREDIT': 'payment-text-store-credit',
                    'FINANCE': 'payment-text-finance',
                    'TAX EXEMPT': 'payment-text-tax-exempt'
                };
                if (typeof method === 'string' && method.startsWith('FINANCE: ')) return 'payment-text-finance';
                if (typeof method === 'string' && method.startsWith('TAX EXEMPT: ')) return 'payment-text-tax-exempt';
                return classMap[method] || 'payment-text-default';
            },
            showPaymentHistory: function(sale) {
                console.log('Raw payment methods data:', sale.all_payment_methods);
                this.selectedInvoice = { ...sale };
                const paymentMethodsToUse = sale.all_payment_methods || sale.payment_methods;
                if (paymentMethodsToUse && Array.isArray(paymentMethodsToUse) && paymentMethodsToUse.length > 0) {
                    this.selectedInvoice.payment_details = paymentMethodsToUse.map(payment => ({
                        ts: payment.ts,
                        value: payment.value,
                        amount: payment.amount,
                        name: payment.name,
                        store_credit_invoice_id: payment.store_credit_invoice_id,
                        charged_tax_itself: payment.charged_tax_itself,
                        lease_id: payment.lease_id,
                        misc_info: payment.misc_info
                    }));
                    console.log('Mapped payment details:', this.selectedInvoice.payment_details);
                } else {
                    this.selectedInvoice.payment_details = [];
                    console.log('No payment methods found or empty array');
                }
                this.$bvModal.show('payment-history-modal');
            },
            formatPaymentDate: function(dateString) {
                if (!dateString) return 'N/A';
                try {
                    return moment(dateString).format('MMM DD, YYYY hh:mm A');
                } catch (e) {
                    return dateString;
                }
            },
            getPaymentMethodsDisplay: function(paymentMethods) {
                if (!paymentMethods || paymentMethods.length === 0) return [];
                if (paymentMethods.length > 0 && typeof paymentMethods[0] === 'object') {
                    const methodMap = {
                        'cash': 'CASH',
                        'cc': 'CC',
                        'store_credit': 'STORE CREDIT',
                        'finance': 'FINANCE',
                        'tax_exempt': 'TAX EXEMPT'
                    };
                    const uniqueMethods = [...new Set(
                        paymentMethods
                            .filter(method => method && method.value)
                            .map(method => {
                                const baseMethod = methodMap[method.value] || method.value.toUpperCase();
                                if (method.value === 'finance' && method.name && method.name !== 'N/A') return `FINANCE: ${method.name}`;
                                if (method.value === 'tax_exempt' && method.name && method.name !== 'N/A') return `TAX EXEMPT: ${method.name}`;
                                return baseMethod;
                            })
                    )];
                    return uniqueMethods;
                }
                const methodMap = {
                    'cash': 'CASH',
                    'cc': 'CC',
                    'store_credit': 'STORE CREDIT',
                    'finance': 'FINANCE',
                    'tax_exempt': 'TAX EXEMPT'
                };
                const uniqueMethods = [...new Set(
                    paymentMethods
                        .filter(method => method != null)
                        .map(method => {
                            if (typeof method === 'string' && method.startsWith('FINANCE - ')) return method.replace('FINANCE - ', 'FINANCE: ');
                            if (typeof method === 'string' && method.startsWith('TAX_EXEMPT - ')) return method.replace('TAX_EXEMPT - ', 'TAX EXEMPT: ');
                            return methodMap[method] || (typeof method === 'string' ? method.toUpperCase() : 'UNKNOWN');
                        })
                )];
                return uniqueMethods;
            },
            getPaymentMethodIcon: function(method) {
                const iconMap = {
                    'cash': '💵',
                    'cc': '💳',
                    'store_credit': '📋',
                    'finance': '🏦',
                    'tax_exempt': '🧾'
                };
                return iconMap[method] || '💰';
            },
            getPaymentMethodClass: function(method) {
                const classMap = {
                    'cash': 'cash-method',
                    'cc': 'cc-method',
                    'store_credit': 'store-credit-method',
                    'finance': 'finance-method',
                    'tax_exempt': 'tax-exempt-method'
                };
                return classMap[method] || 'default-method';
            },
            isRecentPayment: function(dateString) {
                if (!dateString) return false;
                try {
                    const paymentDate = moment(dateString);
                    const daysDiff = moment().diff(paymentDate, 'days');
                    return daysDiff <= 7;
                } catch (e) {
                    return false;
                }
            },
            navigateToSelectedInvoice: function() {
                if (this.selectedInvoice) {
                    this.$bvModal.hide('payment-history-modal');
                    this.$router.push("/sales/viewsale/" + this.selectedInvoice.invoice_id + "/");
                }
            },
            getFilteredLocations: function() {
                const excludedLocations = ["101 WH", "FOLCROFT WH", "9TH ST WH"];
                return this.packet.locations.filter(location => {
                    if (this.packet.userDetails.properties.location_id) {
                        return location.value == this.packet.userDetails.properties.location_id;
                    } else {
                        return !excludedLocations.includes(location.text.toUpperCase());
                    }
                });
            },
            row_part_of_chunk: function(idx) {
                let status = false;
                let that = this;
                if (this.chunk_allowed) {
                    let chunk = this.chunkoptions.filter(function(d) { return d.value == that.chunk_allowed });
                    if (chunk.length > 0) {
                        chunk = chunk[0];
                        if (idx >= chunk.start && idx <= chunk.end) {
                            status = true;
                        }
                    }
                }
                return status;
            },
            chunk_n: function(items) {
                this.chunkoptions = [];
                let n = items.length;
                if (n == 0) {
                    this.chunk_allowed = 0;
                    return;
                }
                let each = this.chunksize;
                if (n <= this.chunksize) {
                    each = n;
                }
                for (var i = 0; i < n; i = i + each) {
                    this.chunkoptions.push({ start: i, end: i + each, value: i + each, text: i + " TO " + (i + each) });
                }
                this.chunk_allowed = this.chunkoptions[0].value;
            },
            total: function() {
                let t = 0.0;
                for (var i = 0; i < this.sales.length; i++) {
                    let sale = this.sales[i];
                    if (this.allowed(sale)) {
                        let amount = this.safeToNumber(sale.payment_amount || sale.paid_so_far);
                        t += amount;
                    }
                }
                return t;
            },
            allowed: function(row) {
                let status = true;
                const isArchived = this.isArchived(row);
                if (this.combined_status_filter !== "archived" && isArchived) return false;
                if (this.sale_type_filter === "layaway") {
                    if (!row.is_layaway || row.transaction_type === "REFUND") status = false;
                }
                if (!status) return false;
                if (this.orderTypeFilter !== "all") {
                    const hasMatchingOrderType = row.items && row.items.some(item => item.order_type === this.orderTypeFilter);
                    if (!hasMatchingOrderType) status = false;
                }
                if (!status) return false;
                if (this.combined_status_filter !== "all") {
                    const currentStatus = this.getStatusDisplay(row);
                    switch(this.combined_status_filter) {
                        case "new": if (currentStatus !== "NEW") status = false; break;
                        case "open": if (currentStatus !== "OPEN") status = false; break;
                        case "processed": if (currentStatus !== "PROCESSED") status = false; break;
                        case "backorder": if (currentStatus !== "BACKORDER") status = false; break;
                        case "partial": if (currentStatus !== "PARTIAL") status = false; break;
                        case "delivered": if (currentStatus !== "DELIVERED") status = false; break;
                        case "completed": if (currentStatus !== "COMPLETED") status = false; break;
                        case "archived": if (!isArchived) status = false; break;
                    }
                }
                if (!status) return false;
                if (this.picked_location_id != null) {
                    if (row.location_id != this.picked_location_id) status = false;
                }
                if (!status) return false;
                if (this.picked_payment_method != null) {
                    var pms = row.payment_methods || [];
                    var picked_payment_method = this.picked_payment_method;
                    var hasMatchingPayment = pms.some(function(payment) {
                        if (!payment || !payment.value) return false;
                        if (picked_payment_method === "CASH") return payment.value === "cash";
                        if (picked_payment_method === "CC") return payment.value === "cc";
                        if (picked_payment_method === "STORE_CREDIT") return payment.value === "store_credit";
                        if (picked_payment_method === "FINANCE") return payment.value === "finance";
                        if (picked_payment_method === "TAX_EXEMPT") return payment.value === "tax_exempt";
                        if (picked_payment_method.startsWith("FINANCE - ")) {
                            return payment.value === "finance" && payment.name === picked_payment_method.replace("FINANCE - ", "");
                        }
                        if (picked_payment_method.startsWith("TAX_EXEMPT - ")) {
                            return payment.value === "tax_exempt" && payment.name === picked_payment_method.replace("TAX_EXEMPT - ", "");
                        }
                        return false;
                    });
                    if (!hasMatchingPayment) status = false;
                }
                return status;
            },
            getInvBg: function(idx) {
                let item = this.sales[idx];
                let payment_methods = item.payment_methods;
                if (item.transaction_type === "REFUND") return "#fff0f0";
                else if (item.is_layaway) return "#f0f8ff";
                else if (payment_methods && payment_methods.some(p => p.value === "finance")) return "rgba(255, 235, 59, 0.2)";
                else return "white";
            },
            search_dates: function(e) {
                if (e) e.preventDefault();
                this.query.invoice_id = null;
                if (!this.query.startDate && !this.query.endDate) {
                    this.fetch_init();
                    return;
                }
                this.fetch_init();
            },
            search_invoice_id: function(e) {
                if (e) e.preventDefault();
                if (!this.query.invoice_id) {
                    this.$bvToast.toast("Please specify a valid invoice id", {title: "Error", autoHideDelay: 1500, variant:"warning"});
                    return;
                }
                this.fetch_init();
            },
            void_invoice: function(invoice_id) {
                let that = this;
                let path = "/api/sales/void_invoice/";
                let data = {invoice_id: invoice_id};
                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(response.data.error, {title: "Error", autoHideDelay: 1500, variant:"warning"});
                    } else {
                        that.$bvToast.toast("DELETED INVOICE SUCCESSFULLY", {title: "Success", autoHideDelay: 1500, variant:"success"});
                        that.sales = that.sales.filter(function(d) { return d.invoice_id != invoice_id });
                    }
                    return;
                }
                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast("Error voiding invoice.", {title: "Error", autoHideDelay: 1500, variant:"warning"});
                    return;
                }
                Requestor.postSyncP(path, data, this, s, f);
            },
            fetch_prereqs: function() {
                let that = this;
                let prereqs = [
                    {
                        path: "/api/finance_company/get_all_finance_companies/",
                        data: {},
                        type: "secure",
                        executable: Requestor.getAsyncP,
                        s: function(response) {
                            if (response.data.result) {
                                that.finance_companies = response.data.result;
                            } else {
                                that.$bvToast.toast(response.data.error, {title: "Error", autoHideDelay: 1500, variant:"warning"});
                            }
                        },
                        f: function(error) {
                            that.$bvToast.toast("Error loading finance companies list.", {title: "Error", autoHideDelay: 1500, variant:"warning"});
                        }
                    },
                ];
                for (var i = 0; i < prereqs.length; i++) {
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure") {
                        prereqs[i]["executable"](path, data, this, s, f);
                    } else {
                        prereqs[i]["executable"](path, data, s, f);
                    }
                }
            },
            fetch_init: function() {
                this.startApiLoading("Loading Layaway Sales");
                let that = this;
                let path = "/api/sales/get_sales/";
                let query = JSON.parse(JSON.stringify(this.query));
                if (query.invoice_id) {
                    query.invoice_id = query.invoice_id.replace(/^\s+|\s+$/gm, '');
                    query.startDate = null;
                    query.endDate = null;
                }
                let data = {
                    userid: this.packet.userDetails.id,
                    query: query,
                    status: this.status_filter !== "all" ? this.status_filter : null,
                    invoice_type: "layaway"
                };
                if (this.packet.userDetails.properties.location_id) {
                    data.location_id = this.packet.userDetails.properties.location_id;
                }
                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(response.data.error, {title: "Error", autoHideDelay: 1500, variant:"warning"});
                    } else {
                        that.sales = response.data.result;
                        if (that.sales) {
                            that.sales = that.sales.map(function(d) {
                                d.payment_methods = ((d.payment_methods == null) ? [] : d.payment_methods);
                                d.completed = !!d.completed;
                                d.is_layaway = !!d.is_layaway;
                                d.total_payments = d.total_payments || 1;
                                d.payment_index = d.payment_index || 0;
                                console.log('Invoice:', d.invoice_id, 'Payment:', d.payment_index + 1, 'of', d.total_payments, 'Amount:', d.payment_amount);
                                return d;
                            });
                            that.sales.sort((a, b) => {
                                if (a.completed !== b.completed) return a.completed ? 1 : -1;
                                if (a.is_layaway !== b.is_layaway) return a.is_layaway ? -1 : 1;
                                return 0;
                            });
                        }
                        that.chunk_n(that.sales);
                    }
                    that.sales_being_loaded = false;
                    that.stopApiLoading();
                    return;
                }
                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast("Error loading layaway sales.", {title: "Error", autoHideDelay: 1500, variant:"warning"});
                    that.sales_being_loaded = false;
                    that.stopApiLoading();
                    return;
                }
                this.sales_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            navigateToInvoice: function(idx) {
                let sale = this.sales[idx];
                let invoice_id = sale.invoice_id;
                const routeData = this.$router.resolve({ path: `/sales/viewsale/${invoice_id}/` });
                window.open(routeData.href, "_blank", "noopener,noreferrer");
            },
            sortby: function(key) {
                if (key === 'completed') {
                    if (this.sort_asc) {
                        this.sales.sort((a, b) => {
                            if (a.completed === b.completed) return 0;
                            if (!a.completed && b.completed) return -1;
                            return 1;
                        });
                    } else {
                        this.sales.sort((a, b) => {
                            if (a.completed === b.completed) return 0;
                            if (a.completed && !b.completed) return -1;
                            return 1;
                        });
                    }
                } else if (key === 'status_display') {
                    if (this.sort_asc) {
                        this.sales.sort((a, b) => {
                            const statusA = this.getStatusDisplay(a);
                            const statusB = this.getStatusDisplay(b);
                            return statusA.localeCompare(statusB);
                        });
                    } else {
                        this.sales.sort((a, b) => {
                            const statusA = this.getStatusDisplay(a);
                            const statusB = this.getStatusDisplay(b);
                            return statusB.localeCompare(statusA);
                        });
                    }
                } else {
                    if (this.sort_asc) {
                        this.sales = Requestor.sort(this.sales, key);
                    } else {
                        this.sales = Requestor.sort_reverse(this.sales, key);
                    }
                }
                this.sort_asc = !this.sort_asc;
            },
            get_csv_data: function() {
                let data = [];
                let items = this.sales;
                let that = this;
                if (items && items.length > 0) {
                    for (var i = 0; i < items.length; i++) {
                        let row = items[i];
                        if (!this.allowed(row)) continue;
                        if (!row.items || !Array.isArray(row.items)) continue;
                        for (var j = 0; j < row.items.length; j++) {
                            let element = row.items[j];
                            if (!element) continue;
                            if (element.order_type == 'home_delivery' || element.order_type == 'store_pickup') {
                                let k = {};
                                k["Bill To Name"] = row.customer_fullname || '';
                                k["Email Address"] = row.email || '';
                                k["Ship-to Name"] = row.customer_fullname || '';
                                k["Ship-to Phone"] = (row.customer_phone || '').replace(/\(/g, "").replace(/\)/g, "");
                                k["Ship-to Address Line 1"] = row.address || '';
                                k["Ship-to Address Line 2"] = "";
                                k["Ship-to City"] = row.city || '';
                                k["Stst"] = row.state || '';
                                k["St Postal"] = row.zipcode || '';
                                k["Order No"] = row.invoice_id || '';
                                k["Store"] = this.packet.locsubsdict[row.location_id + "|" + row.sublocation_id] || '';
                                k["Tr Cd"] = 0;
                                let paymentAmount = 0;
                                if (row.is_layaway) {
                                    paymentAmount = this.safeToNumber(row.paid_so_far);
                                } else {
                                    paymentAmount = this.safeToNumber(row.payment_amount || row.grand_total);
                                }
                                k["Order Total"] = this.formatCurrency(paymentAmount);
                                k["Product Description"] = element.product_name || '';
                                k["Stk Lc"] = this.packet.locsubsdict[element.locsub] || '';
                                k["Product Number"] = element.product_sku || '';
                                k["Qty Ord"] = element.quantity || 0;
                                k["Qty Rsvd"] = element.quantity || 0;
                                k["Case Price"] = 0.0;
                                k["Volume"] = element.cubes || 0;
                                k["Del Dates"] = element.delivery_date ? moment(element.delivery_date).format("MM/DD/YYYY") : '';
                                k["Delivery Type"] = element.order_type || '';
                                k["Sale Type"] = row.is_layaway ? "LAYAWAY" : "REGULAR";
                                k["Status"] = this.getStatusDisplay(row);
                                k["Completed"] = row.completed ? "YES" : "NO";
                                let paymentMethod = 'N/A';
                                if (row.payment_methods && row.payment_methods.length > 0 && row.payment_methods[0]) {
                                    paymentMethod = this.getPaymentMethodDisplay(row.payment_methods[0].value);
                                }
                                k["Payment Method"] = paymentMethod;
                                k["Payment Amount"] = this.formatCurrency(paymentAmount);
                                k["Payment Date"] = row.datetime || '';
                                data.push(k);
                            }
                        }
                    }
                }
                return data;
            },
            get_csv_filename: function() {
                let now = moment().format("YYYY-MM-DD_HHmmss");
                return `LAYAWAY_SALES_${now}.csv`;
            },
        },
        created: function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            if (this.packet.userDetails) {
                this.fetch_prereqs();
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize);
            this.stopLoadingAnimation();
        },
        mounted: function() {
            this.handleResize();
            window.addEventListener('resize', this.handleResize);
            const Lightpick = require('lightpick');
            let that = this;
            var picker = new Lightpick({
                field: document.getElementById('layawaydates'),
                singleDate: false,
                repick: true,
                onSelect: function(start, end) {
                    that.query.startDate = start ? start.startOf('day').format('YYYY-MM-DD') : '';
                    that.query.endDate = end ? end.endOf('day').format('YYYY-MM-DD') : '';
                    console.log(that.query);
                }
            });
            this.fetch_init();
        },
    }
</script>

<style scoped>
/* Glass Theme Background */
.glass-theme {
    position: relative;
    background: transparent !important;
    min-height: 100vh;
}

.glass-theme::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('https://m.media-amazon.com/images/I/81eSegKonhL._AC_SL1500_.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    filter: blur(10px);
    opacity: 0.5;
    z-index: -2;
    transform: scale(1.1);
}

/* Page Entrance Animation */
@keyframes fadeInPage {
    from {
        opacity: 0;
        transform: translateY(24px);
        filter: blur(2px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
        filter: blur(0);
    }
}

.fade-in-page {
    animation: fadeInPage 0.7s cubic-bezier(0.2, 0.9, 0.4, 1.1);
}

/* Row Fade Animation */
@keyframes fadeInRow {
    from {
        opacity: 0;
        transform: translateX(-8px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.fade-in-row {
    opacity: 0;
    animation: fadeInRow 0.28s cubic-bezier(0.2, 0.9, 0.4, 1) forwards;
}

/* Glass Filters */
.glass-filters {
    background: rgba(255, 255, 255, 0.85) !important;
    backdrop-filter: blur(10px) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    border-radius: 20px !important;
}

/* Glass Card Inner */
.glass-card-inner {
    background: rgba(255, 255, 255, 0.9) !important;
    backdrop-filter: blur(5px) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    border-radius: 12px !important;
}

/* Glass Input */
.glass-input {
    background: rgba(255, 255, 255, 0.9) !important;
    backdrop-filter: blur(5px) !important;
    border: 1px solid rgba(128, 128, 128, 0.3) !important;
    border-radius: 10px !important;
}

.glass-input:focus {
    border-color: rgba(54, 64, 80, 0.5) !important;
    box-shadow: 0 0 0 2px rgba(54, 64, 80, 0.1) !important;
}

/* Glass Select */
.glass-select {
    background: rgba(255, 255, 255, 0.9) !important;
    backdrop-filter: blur(5px) !important;
    border: 1px solid rgba(128, 128, 128, 0.3) !important;
    border-radius: 10px !important;
}

/* Glass Button Small */
.glass-btn-small {
    background: rgba(54, 64, 80, 0.85) !important;
    color: white !important;
    border: none !important;
    border-radius: 8px !important;
    padding: 4px 12px !important;
    transition: all 0.2s ease !important;
}

.glass-btn-small:hover {
    background: rgba(54, 64, 80, 1) !important;
    transform: translateY(-1px) !important;
}

.glass-btn {
    background: linear-gradient(135deg, rgba(54, 64, 80, 0.9), rgba(54, 64, 80, 0.95)) !important;
    color: white !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    transition: all 0.2s ease !important;
    border-radius: 10px !important;
}

.glass-btn:hover:not(:disabled) {
    background: linear-gradient(135deg, rgba(54, 64, 80, 1), rgba(54, 64, 80, 1)) !important;
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
}

.glass-btn-outline {
    background: rgba(255, 255, 255, 0.8) !important;
    backdrop-filter: blur(5px) !important;
    border: 1px solid rgba(54, 64, 80, 0.3) !important;
    transition: all 0.2s ease !important;
    border-radius: 10px !important;
}

.glass-btn-outline:hover {
    background: rgba(54, 64, 80, 0.1) !important;
    transform: translateY(-1px) !important;
}

/* Glass Table */
.glass-table {
    background: rgba(255, 255, 255, 0.7) !important;
    border-radius: 16px !important;
    overflow: hidden;
}

.glass-table th {
    background: rgba(0, 0, 0, 0.05) !important;
    color: white !important;
    font-weight: 600 !important;
    padding: 10px !important;
}

.glass-table td {
    background: rgba(255, 255, 255, 0.5) !important;
    padding: 8px !important;
}

.glass-table tr:hover td {
    background: rgba(255, 255, 255, 0.8) !important;
}

/* Glass Progress */
.glass-progress :deep(.progress-bar) {
    transition: width 0.6s cubic-bezier(0.2, 0.9, 0.4, 1.1);
}

/* Glass Modal */
.glass-modal >>> .modal-content {
    background: rgba(255, 255, 255, 0.98) !important;
    backdrop-filter: blur(20px) !important;
    border: 1px solid rgba(255, 255, 255, 0.5) !important;
    border-radius: 24px !important;
}

/* Sort Icon */
.sort-icon {
    margin-left: 5px;
    font-size: 11px;
    opacity: 0.7;
}

/* Customer Cell */
.customer-cell {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.customer-phone {
    font-size: 11px;
    color: #64748b;
}

/* Payment Methods */
.payment-methods-compact {
    font-size: 10px;
    line-height: 1.2;
    text-align: center;
}

.payment-text-cash { color: #28a745; font-weight: bold; }
.payment-text-cc { color: #17a2b8; font-weight: bold; }
.payment-text-store-credit { color: #ffc107; font-weight: bold; }
.payment-text-finance { color: #6f42c1; font-weight: bold; }
.payment-text-tax-exempt { color: #dc3545; font-weight: bold; font-style: italic; }
.payment-text-default { color: #6c757d; font-weight: normal; }

.highlight-match {
    background-color: rgba(232, 245, 232, 0.8) !important;
    border-left: 3px solid #28a745;
}

.totals-row {
    background-color: rgba(255, 235, 59, 0.3) !important;
}

/* Loading Overlay Styles - FIXED HEIGHT VERSION */
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.85);
    backdrop-filter: blur(20px);
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
}

.loading-overlay-enter-active {
    animation: fadeInLoad 0.3s ease;
}

.loading-overlay-leave-active {
    animation: fadeOutLoad 0.3s ease;
}

@keyframes fadeInLoad {
    from { opacity: 0; backdrop-filter: blur(0px); }
    to { opacity: 1; backdrop-filter: blur(20px); }
}

@keyframes fadeOutLoad {
    from { opacity: 1; backdrop-filter: blur(20px); }
    to { opacity: 0; backdrop-filter: blur(0px); }
}

.glass-loader-card {
    background: rgba(255, 255, 255, 0.98) !important;
    backdrop-filter: blur(20px) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    border-radius: 24px !important;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
}

.loading-card {
    padding: 48px 56px;
    text-align: center;
    animation: scaleIn 0.35s cubic-bezier(0.34, 1.2, 0.64, 1);
    min-width: 380px;
    min-height: 420px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

@keyframes scaleIn {
    from { transform: scale(0.9); opacity: 0; }
    to { transform: scale(1); opacity: 1; }
}

.loading-animation {
    margin-bottom: 24px;
    flex-shrink: 0;
}

.loading-ring {
    position: relative;
    width: 80px;
    height: 80px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ring {
    position: absolute;
    width: 100%;
    height: 100%;
    border: 3px solid transparent;
    border-radius: 50%;
    animation: ringRotate 1.5s linear infinite;
}

.ring:nth-child(1) {
    border-top-color: #4299e1;
    border-left-color: #4299e1;
    animation-duration: 1s;
}

.ring:nth-child(2) {
    border-right-color: #48bb78;
    border-bottom-color: #48bb78;
    width: 80%;
    height: 80%;
    top: 10%;
    left: 10%;
    animation-duration: 1.2s;
    animation-direction: reverse;
}

.ring:nth-child(3) {
    border-left-color: #ed8936;
    border-bottom-color: #ed8936;
    width: 60%;
    height: 60%;
    top: 20%;
    left: 20%;
    animation-duration: 0.8s;
}

@keyframes ringRotate {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.loading-logo {
    font-size: 28px;
    font-weight: bold;
    animation: logoPulse 1.5s ease-in-out infinite;
    z-index: 1;
}

.loading-logo i {
    font-size: 32px;
    background: linear-gradient(135deg, #4299e1, #48bb78);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
}

@keyframes logoPulse {
    0%, 100% { transform: scale(1); opacity: 0.7; }
    50% { transform: scale(1.1); opacity: 1; }
}

.loading-text {
    margin-bottom: 20px;
    flex-shrink: 0;
}

.loading-text h3 {
    color: #2d3748;
    font-size: 1.2rem;
    margin-bottom: 6px;
    display: inline-block;
}

.loading-dots {
    display: inline-flex;
    margin-left: 8px;
}

.loading-dots .dot {
    width: 5px;
    height: 5px;
    background: #4299e1;
    border-radius: 50%;
    margin: 0 2px;
    animation: dotBounce 1.4s ease-in-out infinite;
}

.loading-dots .dot:nth-child(1) { animation-delay: 0s; }
.loading-dots .dot:nth-child(2) { animation-delay: 0.2s; }
.loading-dots .dot:nth-child(3) { animation-delay: 0.4s; }

@keyframes dotBounce {
    0%, 60%, 100% { transform: translateY(0); }
    30% { transform: translateY(-6px); }
}

.loading-progress {
    width: 80%;
    height: 4px;
    background: #e2e8f0;
    border-radius: 4px;
    overflow: hidden;
    margin: 0 auto 20px auto;
    flex-shrink: 0;
}

.progress-bar {
    height: 100%;
    background: linear-gradient(90deg, #4299e1, #48bb78, #ed8936, #4299e1);
    background-size: 200% 100%;
    animation: progressShine 1.5s linear infinite;
    transition: width 0.3s ease;
    border-radius: 4px;
}

@keyframes progressShine {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
}

.loading-tips {
    margin-top: 10px;
    flex-shrink: 0;
    min-height: 65px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.tip-text {
    color: #718096;
    font-size: 0.85rem;
    animation: tipFade 0.5s ease;
    margin: 0;
    padding: 0 15px;
    line-height: 1.4;
}

@keyframes tipFade {
    from {
        opacity: 0;
        transform: translateY(8px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Delivery Dates Modal */
.delivery-dates-content {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.dates-list {
    max-height: 400px;
    overflow-y: auto;
}

.date-item {
    display: flex;
    align-items: center;
    padding: 12px;
    border: 1px solid rgba(224, 224, 224, 0.5);
    border-radius: 8px;
    margin-bottom: 8px;
    background: rgba(255, 255, 255, 0.9);
    transition: all 0.3s ease;
}

.date-item:hover {
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    transform: translateY(-1px);
}

.date-item.upcoming-date {
    border-left: 4px solid #007bff;
    background: rgba(248, 249, 250, 0.9);
}

.date-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, #17a2b8, #6f42c1);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    flex-shrink: 0;
}

.date-details {
    flex: 1;
}

.date-display {
    font-weight: 600;
    color: #333;
    margin-bottom: 2px;
}

.date-status {
    font-size: 12px;
    font-weight: 500;
}

.date-badge {
    margin-left: 8px;
}

.dates-summary {
    background: linear-gradient(135deg, #f8f9fa, #e9ecef);
}

/* Order Types Modal */
.order-types-content {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.order-types-list {
    max-height: 400px;
    overflow-y: auto;
}

.order-type-item {
    display: flex;
    align-items: center;
    padding: 12px;
    border: 1px solid rgba(224, 224, 224, 0.5);
    border-radius: 8px;
    margin-bottom: 8px;
    background: rgba(255, 255, 255, 0.9);
    transition: all 0.3s ease;
}

.order-type-item:hover {
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    transform: translateY(-1px);
}

.order-type-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, #17a2b8, #6f42c1);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    flex-shrink: 0;
}

.order-type-details {
    flex: 1;
}

.order-type-display {
    font-weight: 600;
    color: #333;
    margin-bottom: 2px;
}

.order-type-count {
    font-size: 12px;
    color: #666;
}

.order-type-badge {
    margin-left: 8px;
}

.home-delivery-item { border-left: 4px solid #1565c0; }
.store-pickup-item { border-left: 4px solid #2e7d32; }
.curbside-item { border-left: 4px solid #ef6c00; }
.delivery-item { border-left: 4px solid #7b1fa2; }
.pickup-item { border-left: 4px solid #00695c; }

.order-summary {
    background: linear-gradient(135deg, #f8f9fa, #e9ecef);
}

/* Payment Modal */
.payment-modal-content {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.section-card {
    border: 1px solid rgba(224, 224, 224, 0.5);
    border-radius: 8px;
    overflow: hidden;
}

.section-header {
    background: rgba(248, 249, 250, 0.9);
    padding: 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.section-header-active {
    background: #007bff;
    color: white;
}

.section-title {
    font-weight: 600;
    display: flex;
    align-items: center;
}

.section-content {
    background: rgba(255, 255, 255, 0.9);
}

.payment-list {
    max-height: 300px;
    overflow-y: auto;
}

.payment-item {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid rgba(240, 240, 240, 0.5);
}

.payment-item:hover {
    background-color: rgba(248, 249, 250, 0.8);
}

.payment-item:last-child {
    border-bottom: none;
}

.recent-payment {
    background: linear-gradient(135deg, rgba(255, 243, 205, 0.5), transparent);
}

.payment-method-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    margin-right: 12px;
    flex-shrink: 0;
}

.cash-method {
    background: linear-gradient(135deg, #28a745, #20c997);
    color: white;
}
.cc-method {
    background: linear-gradient(135deg, #17a2b8, #6f42c1);
    color: white;
}
.store-credit-method {
    background: linear-gradient(135deg, #ffc107, #fd7e14);
    color: white;
}
.finance-method {
    background: linear-gradient(135deg, #343a40, #6c757d);
    color: white;
}
.tax-exempt-method {
    background: linear-gradient(135deg, #dc3545, #e83e8c);
    color: white;
}
.default-method {
    background: linear-gradient(135deg, #6c757d, #adb5bd);
    color: white;
}

.payment-details {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.payment-amount {
    font-weight: 600;
    font-size: 16px;
}

.payment-extra {
    margin-left: 12px;
}

.progress-section {
    background: rgba(248, 249, 250, 0.8);
    padding: 12px;
    border-radius: 8px;
}

/* Responsive Styles */
@media (max-width: 768px) {
    .responsive-block {
        display: block !important;
        width: 100% !important;
        margin: 10px 0 !important;
        text-align: left !important;
    }

    .responsive-input {
        width: 100% !important;
        display: block !important;
    }

    .loading-card {
        padding: 32px 24px;
        min-width: 300px;
        min-height: 360px;
    }

    .loading-tips {
        min-height: 55px;
    }

    .tip-text {
        font-size: 0.75rem;
    }

    .glass-table th,
    .glass-table td {
        font-size: 10px;
        padding: 4px !important;
    }

    .date-icon,
    .order-type-icon,
    .payment-method-icon {
        width: 32px;
        height: 32px;
        font-size: 12px;
    }
}

@media (max-width: 576px) {
    .date-item,
    .order-type-item,
    .payment-item {
        padding: 8px;
    }

    .date-icon,
    .order-type-icon,
    .payment-method-icon {
        width: 28px;
        height: 28px;
        margin-right: 8px;
    }

    .date-display,
    .order-type-display {
        font-size: 12px;
    }
}

/* Scrollbar Styling */
.dates-list::-webkit-scrollbar,
.order-types-list::-webkit-scrollbar,
.payment-list::-webkit-scrollbar {
    width: 6px;
}

.dates-list::-webkit-scrollbar-track,
.order-types-list::-webkit-scrollbar-track,
.payment-list::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.dates-list::-webkit-scrollbar-thumb,
.order-types-list::-webkit-scrollbar-thumb,
.payment-list::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.dates-list::-webkit-scrollbar-thumb:hover,
.order-types-list::-webkit-scrollbar-thumb:hover,
.payment-list::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* Original Styles */
.status-badge {
    padding: 3px;
    text-align: center;
    font-weight: bold;
    border-radius: 4px;
    margin-bottom: 2px;
}

.delivery-dates-btn {
    font-size: 10px;
    padding: 2px 8px;
    font-weight: bold;
}

.order-types-btn {
    font-size: 10px;
    padding: 2px 8px;
    font-weight: bold;
}

.order-type-badge {
    padding: 3px;
    text-align: center;
    font-weight: bold;
    border-radius: 4px;
    margin: 2px 0;
    font-size: 10px;
}

.refund-badge {
    background: #ffe6e6;
    color: #dc3545;
    border: 1px solid #dc3545;
    border-radius: 3px;
    padding: 2px 6px;
    font-size: 10px;
    font-weight: bold;
}

.refund-amount {
    color: #dc3545;
    font-weight: bold;
}

.refund-row {
    background: #fff5f5 !important;
}

td {
    font-size: 12px !important;
    padding: 3px;
    background: inherit;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Sales/ListLayAwaySales.vue